export enum DataLayerCustomDimensions {
  Location = 'location',
  event = 'event',
  eventCategory = 'eventCategory',
  eventAction = 'eventAction',
  eventLabels = 'eventLabels',
}
